module.exports = __webpack_public_path__ + "cad7008135a58fda8ec20be42808a6b2.svg";